import { atom } from 'jotai';

const _discoverShownPostCursor = atom(0);

export const $DiscoverShownPostCursor = atom(
  (get) => get(_discoverShownPostCursor),
  (get, set, input: number) => {
    set(_discoverShownPostCursor, Math.max(get(_discoverShownPostCursor), input));
  },
);

export const DISCOVER_SHOWN_POST_BIAS = 2;
